import { render, staticRenderFns } from "./ServicePackTypeSelector.vue?vue&type=template&id=5136598a&"
import script from "./ServicePackTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ServicePackTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports